'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterColumn;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _Tutorial = require('shared/components/Tutorial');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'footer-column';

function FooterColumn(_ref) {
  var title = _ref.title,
      href = _ref.href,
      links = _ref.links;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    href !== '' ? _react2.default.createElement(
      _reactRouter.Link,
      { to: href },
      _react2.default.createElement(
        'h3',
        null,
        title
      )
    ) : _react2.default.createElement(
      'h3',
      null,
      title
    ),
    links.map(function (_ref2) {
      var label = _ref2.label,
          href = _ref2.href,
          id = _ref2.id;

      if (label && href) {
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            key: id,
            to: href
          },
          label
        );
      }

      console.warn('No href found for', label, 'for id', id, 'in', title);
      return null;
    }).filter(function (el) {
      return el;
    }),
    title === 'About Financial Services' ? _react2.default.createElement(_Tutorial.TutorialButton, { to: '/', label: 'Getting Started' }) : null
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/FooterColumn.jsx
// module id = 1123
// module chunks = 0